import {RouterProps} from "../../RouterProps";
import {useStatePair} from "react-type-extension";
import {UserRankValueObject} from "../../../data/value-object/user/UserRankValueObject";
import {UserRankSearchOption} from "../../../data/search-option/user/UserRankSearchOption";
import {SearchIndex} from "../../../io/HttpClient";
import {SortOrder} from "ts-protocol-extension";
import ListPageWrapper from "../../ListPageWrapper";
import {UserRankIO} from "../../../io/UserIO";
import {UserRankDescription} from "../../../data/description/user/UserRankDescription";
import {UserRankDescriptor} from "../../../data/descriptor/user/UserRankDescriptor";
import ListOption from "../../ListOption";
import {
    UserRankSearchOptionDescription
} from "../../../data/description/user/UserRankSearchOptionDescription";
import {
    applyUserRankSearchOption,
    UserRankSearchOptionField
} from "../../search-option-field/user/UserRankSearchOptionField";
import ListOrder from "../../ListOrder";

enum Phase {
    List,
    Option,
    Order
}

export default function List(props: RouterProps) {
    const phase = useStatePair<Phase>(Phase.List)
    const items = useStatePair<UserRankValueObject[]>([])
    const option = useStatePair<UserRankSearchOption>({})
    const index = useStatePair<SearchIndex>({ pageIndex: 0n, sortOrder: [SortOrder.ASC], sortPriority: ['id'] })

    return <>
        {phase.value === Phase.List && <>
            <ListPageWrapper
                {...props}
                client={UserRankIO}
                items={items}
                option={option.value}
                index={index}
                description={UserRankDescription}
                descriptor={UserRankDescriptor}
                showPost
                onPostClick={() => document.location = '/users/ranks/post'}
                showFilter
                onFilterClick={() => phase.setter(Phase.Option)}
                showSort
                onSortClick={() => phase.setter(Phase.Order)}
                onItemClick={item => `/users/ranks/${item.id}`}/>
        </>}
        {phase.value === Phase.Option && <>
            <ListOption
                {...props}
                option={option.value}
                description={UserRankSearchOptionDescription}
                fields={UserRankSearchOptionField}
                onBackClick={() => phase.setter(Phase.List)}
                onApplyClick={(key, value) => {
                    applyUserRankSearchOption(key, value, option)
                    index.setter({ ...index.value, pageIndex: 0n })
                    items.setter([])
                }}
                onDismissClick={key => {
                    const next = { ...option.value }
                    next[key] = undefined
                    option.setter(next)
                    items.setter([])
                }} />
        </>}
        {phase.value === Phase.Order && <>
            <ListOrder
                {...props}
                index={index}
                description={UserRankDescription}
                onBackClick={() => phase.setter(Phase.List)}
                onOrderUpdated={() => items.setter([])} />
        </>}
    </>
}